import { Divider, Typography, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { emailadminService } from '../EmailAdministrationService';
import { useHistory, useParams } from 'react-router-dom';
import { EmailTemplate } from '../Model/EmailAdminModel';
import { Cancel, Save } from '@mui/icons-material';
import JoditTemplateEditor from '../../../Common/JodiEditor/JodiEditor';
import { handleCancel, saveEmailTemplate } from '../Common/Common';
import {
  CardWrapper,
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../../Common/CommonComponents';
import { Loader } from '../../../../Common/Components/Loader';
import CustomButton, {
  CustomTextField,
} from '../../../../Common/Components/Controls/InputControls';
import { useTranslation } from 'react-i18next';

interface Param {
  name: string;
  product: string;
}

const TemplateOperation = () => {
  const { name, product } = useParams<Param>();
  const { t } = useTranslation('emailadministration');
  const [emailTemplate, setEmailTemplate] = useState<EmailTemplate>();
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    loadEmailTemplate();
  }, []);

  const loadEmailTemplate = async () => {
    await emailadminService.getEmailTemplate(name, product).then((template) => {
      setEmailTemplate(template);
      setLoading(false);
    });
  };

  return (
    <>
      <Grid container spacing={3}>
        {loading || emailTemplate === undefined ? (
          <Loader loading={loading} />
        ) : (
          <>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <CardWrapper>
                <Typography variant="h6">Basic Information</Typography>
                <Divider sx={{ mb: 3 }} />
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Template Name </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      {emailTemplate.Name}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Product </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      {emailTemplate.Product}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">E-mail Subject </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomTextField
                      value={emailTemplate.Subject}
                      onChange={(e) =>
                        setEmailTemplate({
                          ...emailTemplate,
                          Subject: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </CardWrapper>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <CardWrapper sx={{ padding: 1 }}>
                <JoditTemplateEditor
                  emailtemplate={emailTemplate}
                  setEmailTemplate={setEmailTemplate}
                />
              </CardWrapper>
            </Grid>
          </>
        )}
      </Grid>
      <FooterWrapper>
        <FooterContainer>
          <Grid item xs={12} sm="auto">
            <CustomButton
              startIcon={<Save />}
              onClick={() =>
                saveEmailTemplate(
                  history,
                  emailTemplate,
                  setLoading,
                  setEmailTemplate,
                  t,
                )
              }
              label="Save"
            />
          </Grid>
          <Grid item xs={12} sm="auto">
            <CustomButton
              startIcon={<Cancel />}
              onClick={() => handleCancel(history)}
              label="Cancel"
            />
          </Grid>
        </FooterContainer>
      </FooterWrapper>
    </>
  );
};

const EditTemplatePage = () => {
  return (
    <div>
      <PaperWrapper>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Edit Template
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <TemplateOperation />
      </PaperWrapper>
    </div>
  );
};

export default EditTemplatePage;
